import { render, staticRenderFns } from "./SynergridEnhanceRequestForm.vue?vue&type=template&id=99010c9a"
import script from "./SynergridEnhanceRequestForm.vue?vue&type=script&lang=ts"
export * from "./SynergridEnhanceRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports